/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_discount_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I find the original price before a discount?`)
};

const es_pct_discount_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo encuentro el precio original antes de un descuento?`)
};

const de_pct_discount_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie finde ich den ursprünglichen Preis vor einem Rabatt?`)
};

const nl_pct_discount_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe vind ik de oorspronkelijke prijs vóór een korting?`)
};

const fr_pct_discount_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment trouver le prix d’origine avant une réduction ?`)
};

const it_pct_discount_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come trovo il prezzo originale prima di uno sconto?`)
};

const pt_br2_pct_discount_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro o preço original antes de um desconto?`)
};

const pt_pct_discount_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como encontro o preço original antes de um desconto?`)
};

const ja_pct_discount_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`割引前の元の価格を求めるには？`)
};

const zh_pct_discount_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何求出折扣前的原价？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_discount_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_discount_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_discount_faq4_q", locale)
	if (locale === "en") return en_pct_discount_faq4_q(inputs)
	if (locale === "es") return es_pct_discount_faq4_q(inputs)
	if (locale === "de") return de_pct_discount_faq4_q(inputs)
	if (locale === "nl") return nl_pct_discount_faq4_q(inputs)
	if (locale === "fr") return fr_pct_discount_faq4_q(inputs)
	if (locale === "it") return it_pct_discount_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_discount_faq4_q(inputs)
	if (locale === "pt") return pt_pct_discount_faq4_q(inputs)
	if (locale === "ja") return ja_pct_discount_faq4_q(inputs)
	return zh_pct_discount_faq4_q(inputs)
};